var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.83 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f3e9d7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "slack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.49,37.93a6.31,6.31,0,1,1-6.31-6.32h6.31Zm3.18,0a6.32,6.32,0,1,1,12.63,0v15.8a6.32,6.32,0,1,1-12.63,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22,12.58A6.32,6.32,0,1,1,28.3,6.27v6.31Zm0,3.18a6.32,6.32,0,0,1,0,12.63H6.18a6.32,6.32,0,0,1,0-12.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M47.34,22.07a6.32,6.32,0,1,1,6.31,6.32H47.34Zm-3.18,0a6.32,6.32,0,1,1-12.63,0V6.26a6.32,6.32,0,1,1,12.63,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.84,47.42a6.32,6.32,0,1,1-6.31,6.31V47.42Zm0-3.18a6.32,6.32,0,0,1,0-12.63H53.65a6.32,6.32,0,1,1,0,12.63Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.04a5f9cf5e5f7d3b41da10c1a7dd32e7.svg";
export { ForwardRef as ReactComponent };